import { ReactComponent as FirstStepIcon } from 'src/assets/svg/first-step.svg';
import { ReactComponent as SecondStepIcon } from 'src/assets/svg/second-step.svg';
import { ReactComponent as ThirdStepIcon } from 'src/assets/svg/third-step.svg';
import { ReactComponent as FourthStepIcon } from 'src/assets/svg/fourth-step.svg';

import { withTranslation } from '@common/helpers';
import classNames from 'classnames';
import { PATHS } from './paths';

export const classes = (isActive: boolean, styles: { [key: string]: string }): string => {
  return classNames(isActive ? styles['active-icon-color-fill'] : styles['inactive-icon-color-fill']);
};

export const STEPS = [
  {
    title: 'step1.title',
    subTitle: 'step1.subtitle',
    icon: (isActive: boolean, styles: { [key: string]: string }) => (
      <FirstStepIcon aria-label={withTranslation('stepper', 'step1.iconLabel')} className={classes(isActive, styles)} />
    ),
    isActive: false,
    isCurrent: false,
  },
  {
    title: 'step2.title',
    subTitle: 'step2.subtitle',
    icon: (isActive: boolean, styles: { [key: string]: string }) => (
      <SecondStepIcon
        aria-label={withTranslation('stepper', 'step2.iconLabel')}
        className={classes(isActive, styles)}
      />
    ),
    isActive: false,
    isCurrent: false,
    path: PATHS.AUTOMATED_AUDIT,
  },
  {
    title: 'step3.title',
    subTitle: 'step3.subtitle',
    icon: (isActive: boolean, styles: { [key: string]: string }) => (
      <ThirdStepIcon aria-label={withTranslation('stepper', 'step3.iconLabel')} className={classes(isActive, styles)} />
    ),
    isActive: false,
    isCurrent: false,
    path: PATHS.WIDGET,
  },
  {
    title: 'step4.title',
    subTitle: 'step4.subtitle',
    icon: (isActive: boolean, styles: { [key: string]: string }) => (
      <FourthStepIcon
        aria-label={withTranslation('stepper', 'step4.iconLabel')}
        className={classes(isActive, styles)}
      />
    ),
    isActive: false,
    isCurrent: false,
    path: PATHS.REPORTED,
  },
];
